var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyIcons11 = function SvgSurveyIcons11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "SurveyIcons-11_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 45 45"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SurveyIcons-11_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-40.87 8.28a4 4 0 0 0-5.46.4l-.58.6-.58-.6a4 4 0 0 0-5.46-.4 4.28 4.28 0 0 0-.29 6.15l5.66 5.91a.91.91 0 0 0 1.33 0l5.66-5.91a4.28 4.28 0 0 0-.28-6.15Z",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".SurveyIcons-11_svg__cls-2{clip-path:url(#SurveyIcons-11_svg__clip-path)}"))), /*#__PURE__*/React.createElement("circle", {
    cx: 22.4,
    cy: 14.32,
    r: 10.32,
    style: {
      fill: "#f68b50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.49 34.72a16.87 16.87 0 0 0-.83-4.22 3.15 3.15 0 0 0-.89-1.5l-.32-.32A9.11 9.11 0 0 0 35.14 27c-.43-.22-.88-.43-1.32-.61l-1.66-.67a1.32 1.32 0 0 0-1.27.16 14.28 14.28 0 0 1-16.84 0 1.32 1.32 0 0 0-1.27-.16l-1.66.67c-.45.18-.89.39-1.32.61a9.11 9.11 0 0 0-2.32 1.66l-.33.34a3.15 3.15 0 0 0-.89 1.54 16.87 16.87 0 0 0-.83 4.22 10.08 10.08 0 0 0-.26 2.1c0 2.13 1.32 3.86 2.95 3.86h28.56c1.66 0 2.95-1.73 2.95-3.86-.04-.72-.07-1.44-.14-2.14Z",
    style: {
      fill: "#4e6b82"
    }
  }));
};
export default SvgSurveyIcons11;